import { takeEvery, fork, put, all, call } from 'redux-saga/effects';

import fetch from './../../../fetch';
import { customHeaders, baseUrl, uaeProjectsBaseURL } from './../../../../../Containers/Config/index';

import { CREATE_SERVICE, CREATE_SERVICE_SUCCESS, CREATE_SERVICE_ERROR } from './../../../actionType';
import { Constant } from '../../../../../Containers/Helpers/constant';
import cogoToast from 'cogo-toast';
import apiCall from '../../../apiCall';

function* createService({ payload }) {
  try {
    const response = yield call(apiCall, {
      url: `${uaeProjectsBaseURL}/admin/services`,
      method: 'POST',
      headers: {
        Authorization: Constant?.CLIENT_TOKEN,
        ...customHeaders,
      },
      data: payload.data,
    });

    if (response.status === 200) {
      cogoToast.success(`${response?.data?.message}`);
      yield put({ type: CREATE_SERVICE_SUCCESS, payload: response });
    } else {
      cogoToast.error(response?.response?.data?.message);
      yield put({ type: CREATE_SERVICE_ERROR, payload: response.error });
    }
  } catch (error) {
    yield put({ type: CREATE_SERVICE_ERROR, payload: error });
  }
}

export function* watchCreateService() {
  yield takeEvery(CREATE_SERVICE, createService);
}

function* createServiceSaga() {
  yield all([fork(watchCreateService)]);
}

export default createServiceSaga;
